import { useState } from 'react';

import endpoints from '../../../../../../../../../api/endpoints';
import { BusinessError } from '../../../../../../../../common/business-error';
import { handleResponseError } from '../../../../../../../../../api/handleResponseError';
import { addParams, fetchWithTokenRefresh } from '../../../../../../../../../api/fetchWithTokenRefresh';

import { Secrets } from './interfaces';
import { OtpValue } from '../interfaces';
import { getOtpVerifyBusinessError } from '../businessErrors';

type DialogError = BusinessError | null;

export const useOtpVerify = () => {
  const [otpVerifyLoading, setLoading] = useState<boolean>(false);
  const [otpVerifyError, setError] = useState<DialogError>(null);

  const handleOtpVerify = async (otp: OtpValue, onSuccess: (secrets: Secrets) => void) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(
        endpoints.clientRegenerateSecretsConfirm,
        addParams('POST', { otp })
      );

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const secrets: Secrets = await response.json();

      onSuccess(secrets);
      setLoading(false);
    } catch (e) {
      const { message, severity } = getOtpVerifyBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return { otpVerifyError, otpVerifyLoading, handleOtpVerify };
};
